import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { PriceGroupsServiceProxy, CreateOrEditPriceGroupDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditPriceGroupModal',
    templateUrl: './create-or-edit-priceGroup-modal.component.html',
    standalone: false,
})
export class CreateOrEditPriceGroupModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    priceGroup: CreateOrEditPriceGroupDto = new CreateOrEditPriceGroupDto();

    constructor(
        injector: Injector,
        private _priceGroupsServiceProxy: PriceGroupsServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(priceGroupId?: number): void {
        if (!priceGroupId) {
            this.priceGroup = new CreateOrEditPriceGroupDto();
            this.priceGroup.id = priceGroupId;

            this.active = true;
            this.modal.show();
        } else {
            this._priceGroupsServiceProxy.getPriceGroupForEdit(priceGroupId).subscribe((result) => {
                this.priceGroup = result.priceGroup;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._priceGroupsServiceProxy
            .createOrEdit(this.priceGroup)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
